import { swedishStateMap } from './swedenStateData';
import { japaneseStateMap } from './japanStateData';

const JAPAN_COUNTRY_CODES = ['JPN', 'JP'];
const SWEDEN_COUNTRY_CODES = ['SWE', 'SE'];
const UAE_COUNTRY_CODES = ['ARE', 'AE'];
const CAYMAN_ISLANDS_COUNTRY_CODES = ['KY', 'CYM'];

const matchesCountryCodes = (countryCode, candidates) =>
  candidates?.indexOf(countryCode) > -1;

const filterByCountry = (externalDataStates, country) => {
  const filteredStates = externalDataStates?.stateRules?.data?.Codes?.filter(
    (state) => {
      const countryAdditionalProperty = state?.AdditionalProperties?.find(
        (additionalProperty) => additionalProperty.Key === 'country_code',
      );
      return countryAdditionalProperty?.Value === country;
    },
  );
  return filteredStates;
};

const translateStateToCode = ({ country, externalDataStates, state }) => {
  let translatedState;
  if (matchesCountryCodes(country, JAPAN_COUNTRY_CODES)) {
    const filteredStates = filterByCountry(externalDataStates, country);
    const candidateState = state;
    const csgState = japaneseStateMap[candidateState];

    translatedState = filteredStates?.find(
      (currentState) => currentState.Name === csgState || state,
    )?.Value;
  }
  if (matchesCountryCodes(country, SWEDEN_COUNTRY_CODES)) {
    const filteredStates = filterByCountry(externalDataStates, country);

    const candidateState = state;
    const csgState = swedishStateMap[candidateState];
    translatedState = filteredStates?.find(
      (currentState) => currentState.Name === csgState,
    )?.Value;
  }
  return translatedState;
};

const translateCodeToState = ({ country, externalDataStates, code }) => {
  let translatedState;
  if (matchesCountryCodes(country, JAPAN_COUNTRY_CODES)) {
    const filteredStates = filterByCountry(externalDataStates, country);
    translatedState = filteredStates?.find(
      (currentState) => currentState.Value === code,
    )?.Name;
  }
  if (matchesCountryCodes(country, SWEDEN_COUNTRY_CODES)) {
    const filteredStates = filterByCountry(externalDataStates, country);

    const candidateState = filteredStates?.find(
      (currentState) => currentState.Value === code,
    )?.Name;

    for (const candidateKey in swedishStateMap) {
      const candidateValue = swedishStateMap[candidateKey];
      if (candidateValue === candidateState) {
        translatedState = candidateKey;
      }
    }
  }
  return translatedState;
};

const translateCityForSpecificCountries = ({ country, state, city }) => {
  let translatedCity;
  const doWeHaveACity = !!(city && city.length > 0);
  const isSupportedCountry =
    matchesCountryCodes(country, UAE_COUNTRY_CODES) ||
    matchesCountryCodes(country, JAPAN_COUNTRY_CODES) ||
    matchesCountryCodes(country, CAYMAN_ISLANDS_COUNTRY_CODES);

  if (isSupportedCountry && !doWeHaveACity) {
    translatedCity = state;
  }
  return translatedCity;
};

export {
  translateCityForSpecificCountries,
  translateStateToCode,
  translateCodeToState,
};
